import { useQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { BffApiClientMolecule } from "../../api-client/store"

export function useBanner() {
  const apiClient = useMolecule(BffApiClientMolecule)

  return useQuery({
    queryKey: ["banner", "content"],
    queryFn: async () => {
      const response = await apiClient.api.banner.content.$get()

      if (!response.ok) throw await response.json()

      return response.json()
    },
    refetchInterval: 30000,
  })
}

export function useBannerContent() {
  const { data } = useBanner()

  return data
}
